import _defineProperty from '@babel/runtime/helpers/defineProperty';
import { jsx } from 'react/jsx-runtime.js';
import cn from 'classnames';
import styles from './Line.module.css.js';

var Line = function Line(props) {
  var _cn;
  var _props$width = props.width,
    width = _props$width === void 0 ? 116 : _props$width,
    _props$height = props.height,
    height = _props$height === void 0 ? 5 : _props$height,
    isDark = props.isDark,
    isBlue = props.isBlue;
  return jsx("span", {
    style: {
      width: width,
      height: height
    },
    className: cn(styles.line, (_cn = {}, _defineProperty(_cn, styles.darkLine, isDark), _defineProperty(_cn, styles.blueLine, isBlue), _cn))
  });
};

export { Line };
